import { ICustomer } from "./customer.types"

export class Customer implements ICustomer {
  id: number
  primary: boolean
  forename: string
  surname: string
  title?: string
  number?: string
  createdAt?: string
  email?: string
  billingAccountIds?: number[]

  constructor(
    id: number,
    primary: boolean,
    forename: string,
    surname: string,
    title?: string,
    number?: string,
    createdAt?: string,
    email?: string,
    billingAccountIds?: { id: number }[],
  ) {
    this.id = id
    this.primary = primary
    this.title = title
    this.forename = forename
    this.surname = surname
    this.number = number
    this.createdAt = createdAt
    this.email = email
    this.billingAccountIds = billingAccountIds?.map(({ id }) => id)
  }

  get formattedName() {
    const fullName = `${this.forename} ${this.surname}`
    return this.title ? `${this.title} ${fullName}` : fullName
  }
}
